//New Entry Form Data: Cohort
const fieldCohortNew = [
    {colMd: "6",
        label: "Level/Year",
        required: true,
        type: "select",
        name: "level_id",
        placeholderData: ["Select Level/Year"]
    },
    {colMd: "6",
        label: "IFSPD Europe Program",
        required: true,
        type: "select",
        name: "program_id",
        placeholderData: ["Select Program"]
    },
    {colMd: "6",
        label: "School",
        required: true,
        type: "select",
        name: "school_id",
        placeholderData: ["Select School"],
        accessRoleIds: [2, 7]
    },
    {colMd: "6",
        label: "Branch",
        required: true,
        type: "select",
        name: "branch_id",
        placeholderData: ["Select Branch"],
        accessRoleIds: [2, 7]
    },
    {colMd: "12",
        label: "Students",
        required: true,
        type: "multi-select",
        name: "student_ids",
        placeholderData: ["Select Students"]
    },
    {colMd: "12",
        label: "Editors (Have all rights: Edit/View/Download)",
        required: false,
        type: "multi-select",
        name: "editor_ids",
        placeholderData: ["Select Editors"]
    }
];
//Values
const fieldValuesCohortNew = {
    level_id: '',
    program_id: '',
    student_ids: '',
    school_id: '',
    branch_id: '',
    editor_ids: ''
};
//Validation
const fieldValidationCohortNew = {
    level_id: 'required||Level/Year',
    program_id: 'required||IFSPD Europe Program',
    student_ids: 'required||Students',
    editor_ids: 'optional||Editors',
};

//Edit Entry Form Data: Cohort
const fieldCohortEdit = [
    {colMd: "12",
        label: "Students",
        required: true,
        type: "multi-select",
        name: "student_ids",
        placeholderData: ["Select Students"]
    }
];
//Values
const fieldValuesCohortEdit = {
    cohort_master_id: '',
    student_ids: ''
};
//Validation
const fieldValidationCohortEdit = {
    cohort_master_id: 'required||Cohort Master Id',
    student_ids: 'required||Students',
};

//Edit-Update Cohort Editors
const fieldCohortEditor = [
    {colMd: "12",
        label: "Editor",
        required: true,
        type: "multi-select",
        name: "editor_ids",
        placeholderData: ["Select Editor"]
    }
];
//Values
const fieldValuesEditor = {
    cohort_master_id: '',
    editor_ids: ''
};
//Validation
const fieldValidationEditor = {
    cohort_master_id: 'required||Cohort Master Id',
    editor_ids: 'optional||Editors',
};

// Nomination Fields
const fieldCohortNomination = [
    {colMd: "6",
        label: "Chair",
        required: true,
        type: "select",
        name: "chair_id",
        placeholderData: ["Select Chair"]
    },
    {colMd: "6",
        label: "Challengers",
        required: true,
        type: "multi-select",
        name: "challenger_ids",
        placeholderData: ["Select Challengers"]
    },
    {colMd: "6",
        label: "Presenter 1",
        required: true,
        type: "select",
        name: "presenter1_id",
        placeholderData: ["Select Presenter 1"],
        optionKey: 'presenter'
    },
    {colMd: "6",
        label: "Mentor 1",
        required: true,
        type: "select",
        name: "mentor1_id",
        placeholderData: ["Select Mentor 1"],
        optionKey: 'mentor'
    },
    {colMd: "6",
        label: "Presenter 2",
        required: true,
        type: "select",
        name: "presenter2_id",
        placeholderData: ["Select Presenter 2"],
        optionKey: 'presenter'
    },
    {colMd: "6",
        label: "Mentor 2",
        required: true,
        type: "select",
        name: "mentor2_id",
        placeholderData: ["Select Mentor 2"],
        optionKey: 'mentor'
    },
    {colMd: "6",
        label: "Presenter 3",
        required: false,
        type: "select",
        name: "presenter3_id",
        placeholderData: ["Select Presenter 3"],
        optionKey: 'presenter'
    },
    {colMd: "6",
        label: "Mentor 3",
        required: false,
        type: "select",
        name: "mentor3_id",
        placeholderData: ["Select Mentor 3"],
        optionKey: 'mentor'
    },
    {colMd: "6",
        label: "Presenter 4",
        required: false,
        type: "select",
        name: "presenter4_id",
        placeholderData: ["Select Presenter 4"],
        optionKey: 'presenter'
    },
    {colMd: "6",
        label: "Mentor 4",
        required: false,
        type: "select",
        name: "mentor4_id",
        placeholderData: ["Select Mentor 4"],
        optionKey: 'mentor'
    },
    {colMd: "12",
        label: "Absentees",
        required: false,
        type: "multi-select",
        name: "absentee_ids",
        placeholderData: ["Select Absentees"]
    },
    {colMd: "12",
        label: "Members",
        required: false,
        type: "multi-select",
        name: "member_ids",
        placeholderData: ["Select Members"],
        readonly: true
    }
];
//Values
const fieldValuesNomination = {
    cohort_master_id: '',
    session_number: '',
    chair_id: '',
    challenger_ids: '',
    member_ids: '',
    absentee_ids: '',
    presenter1_id: '',
    mentor1_id: '',
    presenter2_id: '',
    mentor2_id: '',
    presenter3_id: '',
    mentor3_id: '',
    presenter4_id: '',
    mentor4_id: '',
};
//Validation
const fieldValidationNomination = {
    cohort_master_id: 'required||Cohort Master Id',
    chair_id: 'required||Chair',
    challenger_ids: 'required||Challengers',
    presenter1_id: 'required||Presenter 1',
    mentor1_id: 'required||Mentor 1',
    presenter2_id: 'required||Presenter 2',
    mentor2_id: 'required||Mentor 2',
};

//Award Details
const fieldCohortAward = [
    {colMd: "6",
        label: "Best Presenter",
        required: true,
        type: "select",
        name: "best_presenter_id",
        placeholderData: ["Select Best Presenter"],
        optionKey: 'presenter'
    },
    {colMd: "6",
        label: "Best Mentor",
        required: true,
        type: "select",
        name: "best_mentor_id",
        placeholderData: ["Select Best Mentor"],
        optionKey: 'mentor'
    },
    {colMd: "6",
        label: "Best Challenger",
        required: true,
        type: "select",
        name: "best_challenger_id",
        placeholderData: ["Select Best Challenger"],
        optionKey: 'challenger'
    },
    {colMd: "6",
        label: "Chair Rating (1 to 10)",
        required: true,
        type: "number",
        min:  1,
        name: "chair_rating",
        placeholderData: ["Enter Chair Rating (1 to 10)"]
    },
    {colMd: "6",
        label: "Council Date",
        required: true,
        type: "date",
        date_type: "past",
        name: "council_date",
        placeholderData: ["Council Date"]
    }
];
//Values
const fieldValuesAward = {
    cohort_master_id  : '',
    best_presenter_id : '',
    best_mentor_id    : '',
    best_challenger_id: '',
    chair_rating      : '',
    council_date      : ''
};
//Validation
const fieldValidationAward = {
    cohort_master_id  : 'required||Cohort Master Id',
    best_presenter_id : 'required||Best Presenter',
    best_mentor_id    : 'required||Best Mentor',
    best_challenger_id: 'required||Best Challenger',
    chair_rating: 'required|integer|between:1,10||Chair Rating',
    council_date: 'required||Council Date'
};

// Filter
const filterTableData = [
    {colMd: "3", label: "School", type: "multi-select", name: "school_id", accessRoleIds: [2, 7]},
    {colMd: "3", label: "Branch", type: "multi-select", name: "branch_id", accessRoleIds: [2, 7]},
    {colMd: "3", label: "Program", type: "multi-select", name: "program_id"},
    {colMd: "3", label: "Level/Year", type: "multi-select", name: "level_id"},
    {colMd: "3", label: "Cohort Name", type: "text", name: "cohort_name"},
    {colMd: "3", label: "Student Name", type: "text", name: "student_name"},
    {colMd: "3", label: "Is Completed", type: "select", name: "is_completed"},
];


export {
    // New
    fieldCohortNew,
    fieldValuesCohortNew,
    fieldValidationCohortNew,
    //Edit
    fieldCohortEdit,
    fieldValuesCohortEdit,
    fieldValidationCohortEdit,
    //Editor
    fieldCohortEditor,
    fieldValuesEditor,
    fieldValidationEditor,
    // Nomination
    fieldCohortNomination,
    fieldValuesNomination,
    fieldValidationNomination,
    //Award
    fieldCohortAward,
    fieldValuesAward,
    fieldValidationAward,
    //Filter
    filterTableData
};